
import React, { useState, useRef } from "react";
import * as XLSX from "xlsx";
import { addEmployeeExcel } from "../../api/employeeApi"; // <-- API call for upload
import { useNavigate } from "react-router-dom";

import { hasRight } from "../../utils/userRights";

export default function AddEmployeeExcel() {
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [uploadResult, setUploadResult] = useState(null);

  let username = sessionStorage.getItem("username");

  const fileInputRef = useRef(null); 

  const columnWidths = {
  "Sr.No": "20px",
  "Grade Name":"40px",
  "Gender": "50px",
  "Address": "160px",
  "Email Id": "220px",
  "Birth Date (dd-mm-yyyy)": "160px",
  "Joining Date (dd-mm-yyyy)": "160px"
  // add more 
};

const columnMapping = {
  SrNo: "Sr.No",
  DesignationName: "Designation Name",
  DepartmentName: "Department Name",
  EducationName: "Education Name",
  GradeName: "Grade Name",
  SectionName: "Section Name",
  FirstName: "First Name",
  MiddleName: "Middle Name",
  LastName: "Last Name",
  NameOnAadharCard: "Name On Aadhar Card",
  Gender: "Gender",
  BirthDate: "Birth Date (dd-mm-yyyy)",
  BloodGroup: "Blood Group",
  Address: "Address",   // match backend
  ContactNumber: "Contact Number",
  WhatsAppNumber: "WhatsApp Number",
  EmailId: "Email Id",
  AadharCardNumber: "Aadhar Card Number",
  PANNumber: "PAN Number",
  DrivingLicNo: "Driving Lic. No.",
  PassportNumber: "Passport Number",
  JoiningDate: "Joining Date (dd-mm-yyyy)",
  GrossSalary: "Gross Salary",
  BankAccountNo: "Bank A/c No",
  IFSCCode: "IFSC Code",
  PFAccountNo: "PF Account No",
  UANNumber: "UAN Number",
  ESICNumber: "ESIC Number",
  GratuityNumber: "Gratuity Number",
  MLWFLinNumber: "MLWF Lin Number"
};


const formatDate = (value) => {
  if (!value) return null;

  // Case 1: JS Date object
  // if (value instanceof Date) {
  //   return value.toISOString().split("T")[0] + "T00:00:00";
  // }

  if (value instanceof Date) {
    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, "0");
    const dd = String(value.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T00:00:00`; // local date preserved
  }

  // Case 2: Excel serial number (e.g. 45123)
  if (!isNaN(value)) {
    const excelEpoch = new Date(1899, 11, 30); // Excel epoch (Dec 30, 1899)
    // const jsDate = new Date(excelEpoch.getTime() + value * 86400000);
    // return jsDate.toISOString().split("T")[0] + "T00:00:00";

    const jsDate = new Date(excelEpoch.getTime() + value * 86400000);
    const yyyy = jsDate.getFullYear();
    const mm = String(jsDate.getMonth() + 1).padStart(2, "0");
    const dd = String(jsDate.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T00:00:00`;
  }

  // Case 3: String like dd-mm-yyyy
  if (typeof value === "string") {
    const parts = value.split(/[-/]/); // handles "-" or "/"
    if (parts.length === 3) {
      let [dd, mm, yyyy] = parts;
      if (yyyy.length === 2) yyyy = "20" + yyyy; // handle yy format
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}T00:00:00`;
    }
  }

  return null; // if nothing matches
};


const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (evt) => {
    const data = new Uint8Array(evt.target.result);
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    const excelData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
    setDisplayData(excelData);
    const jsonData = excelData.map((row) => {
    const mappedRow = {};
    Object.keys(columnMapping).forEach((key) => {
  let value = row[columnMapping[key]] || "";

  // Convert numeric-looking fields to string
  if (
    [
      "ContactNumber", "WhatsAppNumber", "Pincode", "PhoneNo1", "PhoneNo2",
      "BankAccountNo", "IFSCCode", "AadharCardNumber", "PANNo", 
      "DrivingLicNo", "PassportNumber", "UANNumber", "ESICNumber", 
      "GratuityNumber", "MLWFLinNumber"
    ].includes(key)
  ) {
    value = value.toString().trim().replace(/,/g, "");
  }

  // Handle dates safely
  if (["BirthDate", "JoiningDate"].includes(key)) {
    value = formatDate(value);
  }

  mappedRow[key] = value;
});

  // Audit fields
  mappedRow.CalculatePT = "Y";
  mappedRow.CalculatePF = "Y";
  mappedRow.HRACalculation = "Y";
  mappedRow.CalculateESIC = "Y";
  mappedRow.CrUser = username || "Unknown";
  mappedRow.CrDate = new Date().toISOString();
  mappedRow.TrUser = null;
  mappedRow.TrDate = null;
  mappedRow.Deleted = "N";

  return mappedRow;
});

    console.log(JSON.stringify(jsonData, null, 2));
    setEmployeeData(jsonData);
    setUploadResult(null);
  };

  reader.readAsArrayBuffer(file);
};

  // Handle Upload to API
  const handleUpload = async () => {
    try {
      const res = await addEmployeeExcel(employeeData); // Example API call
      setUploadResult(res);
      if (res.status) {
        alert("Employees uploaded successfully!");
        navigate("/welcome");
      } else {
        alert("Some issue occurred during upload!");
      }
    } catch (error) {
      alert("Upload failed!");
      console.error(error);
    }
  };

  const handleClear = () => {
    setEmployeeData([]);
    setDisplayData([]);
    setUploadResult(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";  // <-- reset file input
    }
  };

  const formatDisplayDate = (value) => {
    if (!value) return "";
    const iso = formatDate(value); // reuse your backend formatter
    if (!iso) return "";
    const [yyyy, mm, dd] = iso.split("T")[0].split("-");
    return `${dd}-${mm}-${yyyy}`;
  };

  const excelColLabel = (n) => {
      let s = "";
      while (n >= 0) {
        s = String.fromCharCode(65 + (n % 26)) + s;
        n = Math.floor(n / 26) - 1;
      }
    return s;
  };

  return (
    <div className="container mt-4">
      <h2>Import Employees from Excel</h2>
      <input
        type="file"
        accept=".xlsx, .xls"
        className="form-control mb-3"
        onChange={handleFileUpload}
        ref={fileInputRef} 
      />

      {/* Preview Table */}
      <div className="table-responsive mt-3">
        <table className="table table-bordered table-striped table-hover">
          <thead>
            {/* <tr className="small text-muted align-middle" style={{ fontSize: "0.75rem", height: "28px" }}> */}
            <tr className="text-center" style={{fontSize: "0.75rem", height: "28px", backgroundColor: "#ffeeba", color: "#000"}}>
              {Object.keys(columnMapping).map((key, idx) => (
                <th key={`alpha-${idx}`} scope="col" style={{ padding: "6px 8px" }}>
                  {excelColLabel(idx)}
                </th>
              ))}
            </tr>
            <tr className="table-dark"> 
              {/* <th>Sr. No.</th> */}
              {Object.values(columnMapping).map((col, index) => (
                <th key={index} style={{  minWidth: columnWidths[col] || "100px", whiteSpace: "nowrap" }}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayData.length > 0 ? (
              displayData.map((row, index) => (
                <tr key={index}>
                  {Object.keys(columnMapping).map((key, i) => {
                    let value = row[columnMapping[key]];

                    // Format dates for display
                    if (["Birth Date (dd-mm-yyyy)", "Joining Date (dd-mm-yyyy)"].includes(columnMapping[key])) {
                      value = formatDisplayDate(value);
                    }
                  
                    return <td key={i}>{value}</td>;
                  })}

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={Object.keys(columnMapping).length + 1} className="text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Upload Button */}
      {displayData.length > 0 && (
        <div className="mt-3">
          {/* <button onClick={handleUpload} className="btn btn-success me-2">
            Save
          </button> */}

          {hasRight("AddEmployeeExcel", "add") && (
            <button className="btn btn-success me-2" onClick={handleUpload}>
              Save
            </button>
          )}
          
          <button onClick={handleClear} className="btn btn-danger">
            Clear
          </button>
        </div>
      )}
    </div>
  );
}








    // const jsonData = excelData.map((row) => {
    //   const mappedRow = {};

    //   Object.keys(columnMapping).forEach((key) => {
    //     let value = row[columnMapping[key]] || "";

    //     // Convert numeric fields to string
    //     if ([
    //       "PhoneNo1", "PhoneNo2", "BankAccountNo", "IFSCCode",
    //       "AadharCardNumber", "PANNo", "DrivingLicNo", "PassportNo",
    //       "PFAccountNo", "UANNo", "ESICNo", "GratuityNo", "MLWFLinNo"
    //     ].includes(key)) {
    //       value = value.toString();
    //     }

    //     // Convert dates to ISO format
    //     if (["BirthDate", "JoiningDate"].includes(key) && value) {
    //       const parts = value.split("-"); // assumes dd-mm-yyyy
    //       if (parts.length === 3) {
    //         value = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).toISOString();
    //       }
    //     }

    //     mappedRow[key] = value;
    //   });

    //   // Add audit fields
      // mappedRow.CalculatePT = "Y";
      // mappedRow.CalculatePF = "Y";
      // mappedRow.HRACalculation = "Y";
      // mappedRow.CalculateESIC = "Y";
    //   mappedRow.CrUser = "admin";
    //   mappedRow.CrDate = new Date().toISOString();
    //   mappedRow.TrUser = null;
    //   mappedRow.TrDate = null;
    //   mappedRow.Deleted = "N";

    //   return mappedRow;
    // });






// import React, { useState } from "react";
// import * as XLSX from "xlsx";
// import { addEmployeeExcel } from "../../api/employeeApi";
// import { useNavigate } from "react-router-dom";

// export default function AddEmployeeExcel() {
//   const navigate = useNavigate();
//   const [employeeData, setEmployeeData] = useState([]);
//   const [displayData, setDisplayData] = useState([]);
//   const [uploadResult, setUploadResult] = useState(null);

//   // ✅ Handle Excel Upload
//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const data = new Uint8Array(evt.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];

//       let excelData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

//       // Remove Sr.No column if present and add extra fields
//       excelData = excelData.map((row) => {
//         const { "Sr.No": _, ...rest } = row;
//         return {
//           ...rest,
//           CrUser: "admin",
//           CrDate: new Date().toISOString(),
//           TrUser: null,
//           TrDate: null,
//           Deleted: "N",
//         };
//       });

//       setEmployeeData(excelData);
//       setDisplayData(excelData);
//       setUploadResult(null);
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   // ✅ Upload to API
//   const handleUpload = async () => {
//     try {
//         const payload = { employees: employeeData }; // Wrap list in an object
//     const res = await addEmployees(payload);
//     //   const res = await addEmployeeExcel(employeeData);
//       setUploadResult(res);
//       if (res.success) {
//         alert("Employees uploaded successfully!");
//       } else {
//         alert("Some issue occurred during upload!");
//       }
//     } catch (error) {
//       alert("Upload failed!");
//       console.error(error);
//     }
//   };

//   const handleClear = () => {
//     setEmployeeData([]);
//     setDisplayData([]);
//     setUploadResult(null);
//   };

//   return (
//     <div className="container mt-4">
//       <h2>Import Employees from Excel</h2>

//       <input
//         type="file"
//         accept=".xlsx, .xls"
//         className="form-control mb-3"
//         onChange={handleFileUpload}
//       />

//       {/* Preview All Columns */}
//       <div className="table-responsive mt-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
//         <table className="table table-bordered table-striped table-hover">
//           <thead className="table-dark">
//             <tr>
//               <th>Sr. No.</th>
//               {displayData.length > 0 &&
//                 Object.keys(displayData[0]).map((col, index) => (
//                   <th key={index}>{col}</th>
//                 ))}
//             </tr>
//           </thead>
//           <tbody>
//             {displayData.length > 0 ? (
//               displayData.map((row, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   {Object.keys(displayData[0]).map((key, i) => (
//                     <td key={i}>{row[key]}</td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={2} className="text-center">
//                   No data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Buttons */}
//       {displayData.length > 0 && (
//         <div className="mt-3">
//           <button onClick={handleUpload} className="btn btn-success me-2">
//             Save
//           </button>
//           <button onClick={handleClear} className="btn btn-danger">
//             Clear
//           </button>
//         </div>
//       )}

//       {/* API Response */}
//       {uploadResult && (
//         <div className="alert alert-info mt-3">
//           <p>{uploadResult.message}</p>
//           {uploadResult.duplicates?.length > 0 && (
//             <p>
//               <strong>Duplicates Skipped:</strong> {uploadResult.duplicates.join(", ")}
//             </p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
